import { useEffect, useState } from "react";
import CustomText from "../atomic/CustomText";
interface CustomImageViewerProps {
  readonly imageUrl: string;
  readonly className?: string;
  readonly imageTitle: string;
  readonly roundedImage?: boolean;
  readonly showLoadingIndication?: boolean
}
function CustomImageViewer({
  imageUrl,
  className,
  imageTitle,
  roundedImage,
  showLoadingIndication,
}: CustomImageViewerProps): JSX.Element {
  const [imageError, setImageError] = useState<boolean>(false);

  useEffect(() => {
    setImageError(false);
  }, [imageUrl]);

  function handleImageError() {
    setImageError(true);
    // Log error for debugging (can be removed in production)
    console.warn(`Failed to load image: ${imageUrl}`);
  }

  // Check if imageUrl is empty or just whitespace
  if (!imageUrl || imageUrl.trim() === "") {
    return (
      <figure
        className={`${roundedImage
          ? "object-fit w-[7rem] h-[7rem] rounded-full"
          : "max-w-[316px] h-[68px] rounded-md"
          } border border-dashed bg-sideMenuHoverBg flex flex-col items-center justify-center overflow-hidden ${className}`}
      >
        <img
          src={require("../../assets/images/NoImage.png")}
          alt={imageTitle}
          onError={handleImageError}
          className={`${imageError
            ? "h-[28px] w-[28px] m-auto object-center"
            : "h-full w-full"
            }`}
        />
      </figure>
    );
  }

  return (
    <figure
      className={`${roundedImage
        ? "object-fit w-[7rem] h-[7rem] rounded-full"
        : "max-w-[316px] h-[68px] rounded-md"
        } border border-dashed bg-sideMenuHoverBg flex flex-col items-center overflow-hidden ${className}`}
    >
      {showLoadingIndication && (
        <div className={"bg-dropDownBorder animate-pulse w-full h-full"} />
      )}
      {!showLoadingIndication && (
        <img
          src={imageError ? require("../../assets/images/NoImage.png") : imageUrl}
          alt={imageTitle}
          onError={handleImageError} // Use `onError` instead of `onErrorCapture`
          className={`${imageError
            ? "h-[28px] w-[28px] m-auto object-center"
            : "h-full w-full"
            }`}
        />
      )}
    </figure>
  );
}
export default CustomImageViewer;